export const AT_HOME_GET_SEMINARS_SUCCESS = 'AT_HOME_GET_SEMINARS_SUCCESS';
export const AT_HOME_GET_SEMINARS_FAILURE = 'AT_HOME_GET_SEMINARS_FAILURE';
